import keys from '@debbie/common/dist/cache/keys.js';
import { Entity } from '@debbie/common/dist/index.js';
import { caseFilterhash, } from '@debbie/common/dist/insights/index.js';
import * as api from '../api/cases.js';
import { caseVouchersEntity, caseVouchersKeyByCase, } from '../case-vouchers/index.js';
import { connectCaseMappingOnCaseKey, connectMappingsEntity, } from '../connect/index.js';
import { creditorKey, creditorsEntity } from '../creditors/index.js';
import { customerKey, customersEntity } from '../customers/index.js';
import { registriesByCaseIdKey, registriesEntity, } from '../debt-registries/index.js';
import { documentsByReferenceKey, documentsEntity } from '../documents/index.js';
import { insightsScopeKey } from '../insights/filter-params.js';
import { interactionsByReferenceKey, interactionsEntity, } from '../interactions/index.js';
import { paymentPlansByCaseIdKey, paymentPlansEntity, } from '../paymentPlans/index.js';
import { propertiesEntity, propertiesKey } from '../properties/index.js';
import q from '../query.js';
import * as socket from '../socket.js';
import { tribunalCasesByCaseIdKey, tribunalCasesEntity, tribunalJobsEntity, } from '../tribunal/index.js';
import { updatesByRefIdKey, updatesEntity } from '../updates/index.js';
import { wincentPredictionKey } from '../wincent/index.js';
export const casesEntity = 'cases';
const caseInsightsTotalsKey = `case-insights-totals`;
export const useCaseInsightsTotals = () => q.query(caseInsightsTotalsKey, api.getInsightsTotals, keys.read.collection(casesEntity));
const caseKey = (id) => `cases-${id}`;
export const useCase = (id) => q.query(caseKey(id), () => api.getById(id), keys.read.item(casesEntity, id), {
    enabled: id != null,
    onSuccess: (res) => {
        socket.caseLoaded(res.tenantId, res.id);
    },
});
export const ensureCaseLoaded = (id) => q.ensureLoaded(caseKey(id));
const caseListKey = (caseFilter, page, pageSize, filters, creditorId) => `cases-list-${caseFilterhash(caseFilter)}-${page}-${pageSize}-${filters?.customerId || ''}-${creditorId}-${filters?.associationId}`;
export const useCaseList = (caseFilter, page, pageSize, filters, creditorId) => q.query(caseListKey(caseFilter, page, pageSize, filters, creditorId), () => api.getAll(caseFilter, page * pageSize, pageSize, filters, creditorId), keys.read.collection(casesEntity));
const caseStatusInsightsKey = (from, to) => `cases-status-insights-${from}-${to}`;
export const useCaseStatusInsights = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${caseStatusInsightsKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getInsightsStatus(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const caseActiveByMonthKey = (from, to) => `cases-active-by-month-${from}-${to}`;
export const useActiveCasesByMonth = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${caseActiveByMonthKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getInsightsActiveByMonth(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const caseAgeDistributionKey = 'cases-age-distribution';
export const useCaseAgeDistribution = ({ caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${caseAgeDistributionKey}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getInsightsAgeDistribution({
    caseGroupIds,
    creditorIds,
}), []);
const topCreditorsByBalanceKey = 'cases-top-creditors-by-balance';
export const useTopCreditorsByBalance = ({ caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${topCreditorsByBalanceKey}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getInsightsTopCreditorsByBalance({
    caseGroupIds,
    creditorIds,
}), []);
const resolutionRateOverviewKey = (from, to) => `cases-resolution-rate-overview-${from}-${to}`;
export const useResolutionRateOverview = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${resolutionRateOverviewKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getResolutionRateOverview(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const resolutionRateByMonthKey = (from, to) => `cases-resolution-rate-by-month-${from}-${to}`;
export const useResolutionRateByMonth = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${resolutionRateByMonthKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getResolutionRateByMonth(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const resolutionRateByEndReasonKey = (from, to) => `cases-resolution-rate-by-end-reason-${from}-${to}`;
export const useResolutionRateByEndReason = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${resolutionRateByEndReasonKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getResolutionRateByEndReason(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const resolutionRateSpeedBucketsKey = (from, to) => `cases-resolution-rate-speed-buckets-${from}-${to}`;
export const useResolutionRateSpeedBuckets = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${resolutionRateSpeedBucketsKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getResolutionRateSpeedBuckets(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
/** Only made for caseworker at the moment (Could leak data on other clients) */
export const prefetchCaseData = (caseId) => q.prefetch(`cases-${caseId}`, () => api.bulk(caseId), {
    [caseKey(caseId)]: {
        extract: (r) => r.case,
        dependencies: keys.read.item(casesEntity, caseId),
    },
    [updatesByRefIdKey(caseId)]: {
        extract: (r) => r.updates,
        dependencies: keys.read.collection(updatesEntity),
    },
    // TODO: deleted option
    [caseVouchersKeyByCase(caseId, {})]: {
        extract: (r) => r.caseVouchers,
        dependencies: keys.read.collection(caseVouchersEntity),
    },
    [documentsByReferenceKey(caseId)]: {
        extract: (r) => r.documents,
        dependencies: keys.read.collection(documentsEntity),
    },
    [interactionsByReferenceKey(Entity.Case, caseId)]: {
        extract: (r) => r.interactions,
        dependencies: keys.read.collection(interactionsEntity),
    },
    [paymentPlansByCaseIdKey(caseId)]: {
        extract: (r) => r.paymentPlans,
        dependencies: keys.read.collection(paymentPlansEntity),
    },
    [tribunalCasesByCaseIdKey(caseId)]: {
        extract: (r) => r.tribunalCases,
        dependencies: [
            ...keys.read.collection(tribunalCasesEntity),
            ...keys.read.collection(tribunalJobsEntity), // TODO: Scoped keys
        ],
    },
    [propertiesKey(Entity.Case, caseId)]: {
        // TODO: scope
        extract: (r) => r.properties,
        dependencies: keys.read.collection(propertiesEntity),
    },
    [connectCaseMappingOnCaseKey(caseId)]: {
        extract: (r) => r.connectMappings,
        dependencies: keys.read.collection(connectMappingsEntity),
    },
    [registriesByCaseIdKey(caseId)]: {
        extract: (r) => r.debtRegistrations,
        dependencies: keys.read.collection(registriesEntity),
    },
    [wincentPredictionKey(caseId)]: {
        extract: (r) => r.wincentPrediction,
        dependencies: [...keys.read.item(casesEntity, caseId)],
    },
    creditor: {
        extract: (r) => r.creditor,
        dynamicKey: (r) => creditorKey(r.creditor.creditorId),
        dependencies: (r) => keys.read.item(creditorsEntity, r.creditor.creditorId),
    },
    customer: {
        extract: (r) => r.customer,
        dynamicKey: (r) => customerKey(r.customer.customerId),
        dependencies: (r) => keys.read.item(customersEntity, r.customer.customerId),
    },
}, {
    enabled: caseId != null,
    onSuccess: (res) => {
        socket.caseLoaded(res.case.tenantId, res.case.id);
    },
});
//# sourceMappingURL=index.js.map